export const userUpdateQuery = `mutation MyMutation($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    accountId
    accountType
    email
    phone
    firstName
    lastName
    enabled
    role
    createdByUserId
    inviteEmailStatus
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
  }
}`;
